import React from "react";
import impulseLogo from "assets/logos/impulse_logo.png";
import kandaLogo from "assets/logos/kanda_logo.png";
import LanguageDropDown from "features/LanguageDropDown";

import styles from "./styles.module.scss";

const Header: React.FC<{ className: string }> = ({ className }) => {
    return (
        <header className={`${className} ${styles.header}`}>
            <div>
                <img
                    src={kandaLogo}
                    alt="Kanda"
                    className={styles.kandaLogo}
                />
            </div>
            <div>
                <img src={impulseLogo} alt="Impulse" className={styles.logo} />
            </div>
            <LanguageDropDown />
        </header>
    );
};

export default Header;
